import api from '@/api/api'
import router from '@/router/index'

export default {
  namespaced: true,
  state: {
    userCleaner: {},
    loaded: false,
    sessionChecked: false,
    checkingSession: false
  },
  mutations: {
    setUser(state, userCleaner) {
      console.log('vacio el usuario')
      state.userCleaner = Object.assign(state.userCleaner, userCleaner)
    },
    logout(state) {
      state.userCleaner = {}
    },
    loaded(state, payload) {
      state.loaded = payload
    },
    sessionChecked(state, payload) {
      state.sessionChecked = payload
    },
    checkingSession(state, payload) {
      state.checkingSession = payload
    }
  },
  actions: {
    restore({ commit }) {
      const userCleanerJson = localStorage.getItem('userCleaner')
      let userCleaner = null
      if (userCleanerJson !== null) {
        userCleaner = JSON.parse(userCleanerJson)
      }
      if (userCleaner !== null) {
        commit('setUser', userCleaner)
      }
    },
    async login({ commit }, { email, password }) {
      return new Promise((resolve, reject) => {
        api
          .post('/login/login_cleaner', {
            email,
            password
          })
          .then(response => {
            if (response.data.error == null) {
              const userCleaner = response.data
              localStorage.setItem('userCleaner', JSON.stringify(userCleaner))
              commit('setUser', userCleaner)
              commit('sessionChecked', true)
              resolve(response.data)
            } else {
              reject(response.data.error)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async cambiarContraseña({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .post('/login/cambiar_passwordCMS', obj)
          .then(response => {
            if (response.data.error == null) {
              resolve(response.data)
            } else {
              reject(response.data.error)
            }
          })
          .catch(e => {
            dispatch()
            reject(e)
          })
      })
    },
    async logout({ commit }) {
      try {
        await api.post('/login/logoutCMS')
        console.log('termino el logout')
        commit('setUser', {})
        // eslint-disable-next-line
      } catch (e) {
        console.log(e)
      } finally {
        // commit('sessionChecked', false)

        localStorage.removeItem('userCleaner', null)
        commit('logout')
        router.push({ name: 'loginCleaner' })
      }
    },
    async resetPassword({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .post('/login/reset_pwCMS', obj)
          .then(response => {
            if (response.data.error == null) {
              resolve()
            } else {
              reject(response.data.error)
            }
          })
          .catch(e => {
            dispatch()
            reject(e)
          })
      })
    },
    async modificarPassword({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .post('/login/set_pwCleanerCMS', obj)
          .then(response => {
            if (response.data.error == null) {
              resolve()
            } else {
              reject(response.data.error)
            }
          })
          .catch(e => {
            dispatch()
            reject(e)
          })
      })
    },
    async checkSession({ commit }) {
      try {
        await api.get('/login/check_sessionCMS')
        commit('sessionChecked', true)
      } catch (e) {
        commit('logout')
        localStorage.removeItem('userCleaner')
        throw e
      }
    },
    setLoaded({ commit }, payload) {
      commit('loaded', payload)
    },
    setSessionChecked({ commit }, payload) {
      commit('sessionChecked', payload)
    },
    setCheckingSession({ commit }, payload) {
      commit('checkingSession', payload)
    }
  },
  getters: {
    userCleaner(state) {
      return state.userCleaner
    },
    loaded(state) {
      return state.loaded
    },
    sessionChecked(state) {
      return state.sessionChecked
    },
    checkingSession(state) {
      return state.checkingSession
    },
    loggedIn(state) {
      return state.userCleaner.id != null
    }
  }
}
